import {useKeycloak} from '@react-keycloak/web';
import jwt from 'jwt-decode';
import {useCookies} from 'react-cookie';
import {Event} from '../queries/event';

export const useSynchronisation = () => {
  const {keycloak} = useKeycloak();

  const [cookies, setCookie] = useCookies(['isCalendarCreated']);

  const getUserId = () => {
    try {
      const decodedToken = jwt(keycloak.token);
      return decodedToken.sub;
    } catch {
      return null;
    }
  };

  const createEvent = (
    description,
    title,
    dateStart,
    dateEnd,
    location,
    eventId,
  ) => {
    const newDescription = description.replace(/\n/g, ' ');
    const body = `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nDTSTART:${dateStart}\nDTEND:${dateEnd}\nDTSTAMP:${dateStart}\nUID:nextcloud-${dateStart}${Date.now()}\nDESCRIPTION:${newDescription}\nLOCATION:${location}\nSUMMARY:${title}\nEND:VEVENT\nEND:VCALENDAR`;
    const userId = getUserId();
    userId && Event.syncCreateEvent(body, userId, keycloak.token, eventId);
  };

  const deleteEvent = eventId => {
    const userId = getUserId();
    userId &&
      Event.syncDeleteEvent(`${eventId}-${userId}`, userId, keycloak.token);
  };

  const checkIfCalendarNextCloudIsCreated = async () => {
    const userId = getUserId();
    console.log(userId);
    if (!userId) return;

    await Event.getPersonalCalendar(keycloak.token, userId).then(res => {
      if (res) {
        setCookie('isCalendarCreated', true);
      } else {
        Event.makeMKCalendarRequest(keycloak.token, userId)
          .then(() => {
            setCookie('isCalendarCreated', true);
          })
          .catch(() => {
            setCookie('isCalendarCreated', false); //TODO remomter l'alerte et l'afficher à l'utilisateur
          });
      }
    });
  };
  return {createEvent, deleteEvent, checkIfCalendarNextCloudIsCreated};
};
